class PaginationComponent extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const link = event.target.closest('a');
    if (!link) return;

    event.preventDefault();
    const url = new URL(link.href);
    this.fetchPage(url);
  }

  async fetchPage(url) {
    // Find the closest shopify section wrapper
    const sectionWrapper = this.closest('[id^="shopify-section-"]');
    if (!sectionWrapper) {
      window.location.href = url.href;
      return;
    }

    const sectionId = sectionWrapper.id.replace('shopify-section-', '');

    // Add section_id to the URL for Section Rendering API
    const fetchUrl = new URL(url.href);
    fetchUrl.searchParams.set('section_id', sectionId);

    try {
      // Add a loading state visually to indicate background processing
      sectionWrapper.classList.add(
        'opacity-50',
        'pointer-events-none',
        'transition-opacity',
        'duration-300',
      );

      const response = await fetch(fetchUrl);
      const htmlText = await response.text();
      const domParser = new DOMParser();
      const newDocument = domParser.parseFromString(htmlText, 'text/html');

      const newSectionWrapper = newDocument.getElementById(
        `shopify-section-${sectionId}`,
      );
      if (!newSectionWrapper) {
        window.location.href = url.href;
        return;
      }

      const source = newSectionWrapper;
      const destination = sectionWrapper;

      if (source && destination && typeof window.wakaMorph === 'function') {
        const updatedSectionWrapper = window.wakaMorph(
          destination,
          source,
          { morphStyle: 'outerHTML' },
          {
            context: 'pagination',
            resolveRoot: () =>
              document.getElementById(`shopify-section-${sectionId}`) ||
              sectionWrapper,
            skipIfVisible: true,
          },
        );

        // Push the new page URL to browser history
        window.history.pushState({}, '', url.href);

        // Smooth scroll to the top of the section wrapper container
        // Provide a small negative offset relative to the block to ensure headers aren't clamped
        const scrollTarget = updatedSectionWrapper || sectionWrapper;
        const yTop =
          scrollTarget.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: yTop, behavior: 'smooth' });

        // Re-sync input-select display after morph
        const inputSelectRoot = updatedSectionWrapper || sectionWrapper;
        window.refreshWakaInputSelects(inputSelectRoot);
      } else {
        window.location.href = url.href;
      }
    } catch (error) {
      console.error('Error fetching pagination content:', error);
      // Fallback to normal navigation if fetch completely fails
      window.location.href = url.href;
    } finally {
      sectionWrapper.classList.remove(
        'opacity-50',
        'pointer-events-none',
        'transition-opacity',
        'duration-300',
      );
    }
  }
}

customElements.define('pagination-component', PaginationComponent);
